var map = {
	"./kensa5_1.jpg": 8936,
	"./kensa5_10.jpg": 4258,
	"./kensa5_11.jpg": 2191,
	"./kensa5_12.jpg": 8576,
	"./kensa5_13.jpg": 7805,
	"./kensa5_14.jpg": 6342,
	"./kensa5_15.jpg": 9507,
	"./kensa5_16.jpg": 7876,
	"./kensa5_17.jpg": 5921,
	"./kensa5_18.jpg": 1130,
	"./kensa5_19.jpg": 5591,
	"./kensa5_1_p.jpg": 2837,
	"./kensa5_2.jpg": 9863,
	"./kensa5_20.jpg": 5991,
	"./kensa5_21.jpg": 2154,
	"./kensa5_22.jpg": 4757,
	"./kensa5_23.jpg": 1240,
	"./kensa5_24.jpg": 7595,
	"./kensa5_2_p.jpg": 5862,
	"./kensa5_3.jpg": 8698,
	"./kensa5_3_p.jpg": 5499,
	"./kensa5_4.jpg": 5161,
	"./kensa5_5.jpg": 3548,
	"./kensa5_6.jpg": 523,
	"./kensa5_7.jpg": 9214,
	"./kensa5_8.jpg": 6957,
	"./kensa5_9.jpg": 7744,
	"./kensa5_example.jpg": 683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1358;